import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from './../app.config';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  domain: string;

  constructor(private appConfig: AppConfig ,private http: HttpClient ,
    private apiconfig :AppConfig) { 
    var apipath='';
        if(this.apiconfig.mpsaFlag==='N'){
          apipath = location.protocol + '//' + this.apiconfig.apiUrl;
        }

      this.domain = apipath+this.apiconfig.apiPath;
  }

    // Method to call a GET request for login headers
    public loginHeaders(url: string, userName: string,password:string):Observable<any> {
      let finalURL =  this.domain + url;
      let options = {
          headers: {
            userName: userName,
            password: password,
            'Content-Type': `application/json ; charset=utf-8` ,
            'Access-Control-Allow-Origin': `*`,
            'Access-Control-Allow-Methods': `GET, POST, PATCH, PUT, DELETE, OPTIONS` ,
            'Access-Control-Allow-Headers': `Origin, Content-Type, X-Auth-Token`

          }
      }
      return this.http.get(finalURL, options);
  }

// Method to call a GET request to get service count
public serviceCount(url: string):Observable<any> {
    let finalURL =  this.domain +url +'?sourceApplication=DMBRBOUI';

    return this.http.get(finalURL);
}

// Method to call a GET request to get contract count
public contractCount(url: string):Observable<any> {
  let finalURL =  this.domain+url +'?sourceApplication=DMBRBOUI';
  return this.http.get(finalURL);
}
}
